import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface InfoTooltipProps {
  text: string;
  position?: 'top' | 'bottom';
}

export function InfoTooltip({ text, position = 'top' }: InfoTooltipProps) {
  const positionClass = position === 'top'
    ? 'bottom-6 left-1/2 -translate-x-1/2'
    : 'top-6 left-1/2 -translate-x-1/2';

  return (
    <div className="relative group inline-flex">
      <InformationCircleIcon className="h-4 w-4 text-white/25 hover:text-white/60 cursor-help transition-colors" />
      <div className={`
        absolute ${positionClass} z-50
        hidden group-hover:block
        w-56 px-3 py-2
        bg-surface-800 border border-white/10
        rounded-lg shadow-xl
        text-xs text-white/70 leading-relaxed
        pointer-events-none
      `}>
        {text}
        <div className={`
          absolute left-1/2 -translate-x-1/2
          ${position === 'top' ? 'top-full border-t-surface-800 border-t-8 border-x-transparent border-x-4 border-b-0' : 'bottom-full border-b-surface-800 border-b-8 border-x-transparent border-x-4 border-t-0'}
        `} />
      </div>
    </div>
  );
}
